export class ProductSearchesCache {
  static indexCacheKey() {
    return 'productsSets';
  }
}
